
module.exports = require('./lib/jquery-deferred');